/**
 * Project 2026-005 — checklist catalog (D-2, §7.1).
 * Steps 4–7 include routes relative to admin basename (`/customers`, etc.).
 */

export const CHECKLIST_STEPS = [
  {
    id: 1,
    title: 'Create your account',
    description: 'Thank you for being here',
    route: null,
    settingsTab: null,
  },
  {
    id: 2,
    title: 'Set up payment',
    description: 'Pay the onboarding fee',
    route: null,
    settingsTab: null,
  },
  {
    id: 3,
    title: 'Set up SMS messaging',
    description: 'The first step to sending campaigns',
    route: null,
    settingsTab: null,
  },
  {
    id: 4,
    title: 'Build your guest list',
    description: 'Import your contacts',
    route: '/customers',
    settingsTab: null,
  },
  {
    id: 5,
    title: 'Set up your site widget',
    description: 'Collect new and returning users',
    route: '/settings',
    settingsTab: 'integration',
  },
  {
    id: 6,
    title: 'Create a QR code',
    description: 'Onboarding made easy',
    route: '/settings',
    settingsTab: 'selfOptIn',
  },
  {
    id: 7,
    title: 'Start your first campaign',
    description: "Let's start filling seats",
    route: '/campaigns',
    settingsTab: null,
  },
];

/** Matches admin usage (e.g. Customers table): SMS/MMS campaigns are “on” once opted in. */
export function organizationSmsCampaignsEnabled(org) {
  return !!(org && org.smsCampaign && org.smsCampaign.OptInAt);
}

/** Steps shown in the checklist; path 7 is omitted when SMS campaigns are not enabled. */
export function getVisibleChecklistSteps(org) {
  if (org != null && !organizationSmsCampaignsEnabled(org)) {
    return CHECKLIST_STEPS.filter((s) => s.id !== 7);
  }
  return CHECKLIST_STEPS;
}

export function isStepComplete(stepId, progress) {
  if (!progress) return false;
  switch (stepId) {
  case 1:
    return !!progress.step1AccountComplete;
  case 2:
    return !!progress.step2PaymentComplete;
  case 3:
    return !!progress.step3SmsComplete;
  case 4:
    return !!progress.guestListComplete;
  case 5:
    return !!progress.widgetComplete;
  case 6:
    return !!progress.qrCodeComplete;
  case 7:
    return !!progress.campaignComplete;
  default:
    return false;
  }
}

export function getFirstIncompleteStepId(progress, org) {
  const visible = getVisibleChecklistSteps(org);
  const step = visible.find((s) => !isStepComplete(s.id, progress));
  return step ? step.id : null;
}
